import React, { ReactElement, useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Box, CircularProgress, Typography } from "@mui/material";
import Row from "./Row";

interface ColumnGroupingTableProps {
  columns: any;
  rows: any;
  head?: ReactElement;
  loading?: boolean;
  setIsEditDialogVisible?: any;
}

const LayoutTable: React.FC<ColumnGroupingTableProps> = ({
  columns,
  rows,
  head,
  loading,
  setIsEditDialogVisible,
}) => {
  const [columnsSortActions, setColumnSortActions] = useState<any>({
    Position: "",
    Name: "",
  });

  const sortableKeys = ["Status", "License", "Date Edited"];
  const [sortBy, setSortBy] = useState<string>("");

  const handleChangeSortBy = (sortVal: string) => {
    setSortBy(sortVal);
    if (sortVal) {
      setColumnSortActions((prevActions: any) => {
        const updatedActions = Object.fromEntries(
          Object.keys(prevActions).map((key) => [
            key,
            key === sortVal
              ? prevActions[key] === "Asc"
                ? "Desc"
                : "Asc"
              : "",
          ])
        );
        return { ...prevActions, ...updatedActions };
      });
    }
  };

  useEffect(() => {}, [sortBy]);

  useEffect(() => {}, [columnsSortActions]);

  return (
    <Paper
      sx={{
        p: "40px",
        borderRadius: "16px",
        backgroundColor: "#000000",
        "&.MuiPaper-root": {
          boxShadow: "none",
          padding: "0px",
          backgroundColor: "#000000",
          backgroundImage: "none",
        },
      }}
    >
      <Box sx={{ position: "relative" }}>
        <TableContainer
          className="HideScrollbar"
          // ref={scrollRef}
          sx={{
            overflowY: "scroll",
            overflowX: "scroll",
            bgcolor: "#141414 !important",
            borderRadius: "16px",
            // maxHeight: `calc(${SECTION_MIN_HEIGHT} - ${"0px"})`,
            // minHeight: `calc(${SECTION_MIN_HEIGHT} - ${"0px"})`,
            height: "75vh",
            scrollbarWidth: "none",
          }}
        >
          <Box
            sx={{
              paddingRight: "24px",
            }}
          >
            {head}
          </Box>
          <Table
            stickyHeader
            sx={{
              padding: "22px 40px",
              paddingRight: "40px",
              "&.MuiTable-root": {
                paddingRight: "40px",
              },
              position: "relative",
            }}
          >
            <TableHead>
              <TableRow
                sx={{
                  borderRadius: "10px",
                  width: "fit-content",
                  borderBottom:
                    "1px solid rgba(255, 255, 255, 0.06) !important",
                  borderTopLeftRadius: "10px",
                  borderBottomLeftRadius: "10px",
                  borderTopRightRadius: "10px",
                  borderBottomRightRadius: "10px",
                  boxShadow: "none !important",
                  "&.MuiTableRow-root": {
                    backgroundColor: "#141414",
                  },
                }}
              >
                {columns?.map((column: any, index: number) => {
                  return (
                    <TableCell
                      sx={{
                        bgcolor: "#141414 !important",
                        color: "rgba(255, 255, 255, 0.5)",
                        "&.MuiTableCell-root": {
                          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
                        },
                      }}
                      key={column?.id}
                      style={{
                        width: "fit-content",
                        // minWidth: index === 0 ? "240px" : "80px",
                        padding: "0px",
                        paddingLeft: "16px",
                        backgroundColor: "transparent",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          height: "100% !important",
                          alignItems: "center",
                          gap: "16px",
                        }}
                      >
                        <Box
                          onClick={() => {
                            handleChangeSortBy(
                              column?.label?.replace(/\s+/g, "")
                            );
                          }}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            gap: "10px",
                            height: "100% !important",
                            cursor: sortableKeys.includes(column.label)
                              ? "pointer"
                              : "default",
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              width: "fit-content",
                              fontWeight: "500",
                              height: "100% !important",
                            }}
                          >
                            {" "}
                            {column.label}
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>
                  );
                })}
                <TableCell
                  sx={{
                    bgcolor: "#141414 !important",
                    color: "rgba(255, 255, 255, 0.5)",
                    "&.MuiTableCell-root": {
                      borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
                    },
                  }}
                  style={{
                    width: "fit-content",
                    padding: "16px 16px 16px 16px",
                    backgroundColor: "transparent",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        gap: "10px",
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          width: "fit-content",
                          fontWeight: "500",
                        }}
                      >
                        Actions
                      </Typography>
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "absolute",
                  right: 0,
                  left: 0,
                  bottom: 0,
                  top: 120,
                  height: "100%",
                }}
              >
                <CircularProgress
                  size={24}
                  sx={{
                    color: "white",
                    marginRight: "12px",
                  }}
                />
              </Box>
            ) : (
              <TableBody>
                {rows
                  ?.sort((a: any, b: any) => {})
                  .map((row: any) => {
                    return (
                      <Row
                        key={row?.id}
                        row={row}
                        setIsEditDialogVisible={setIsEditDialogVisible}
                      />
                    );
                  })}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Box>
    </Paper>
  );
};

export default LayoutTable;
